import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useCart } from 'lib/core/hooks'
import { Button } from 'lib/ui/components'
import { BtnWrap } from '../../styled'
import { useAddPromotionToCart } from 'hooks/useAddPromotionToCart'
import { fetchCart } from 'lib/core/data/quote/cart'

interface Props {
  sku: string
  sizingChart?: string
  [key: string]: any | undefined
  shipmentFrequency: number
  qty: number
  isPromotion?: boolean
  quantityPerDay?: number
  onSuccess?: (param: boolean) => void
}

export const AddToCart: React.FC<Props> = ({
  sku,
  shipmentFrequency,
  qty,
  isPromotion = true,
  quantityPerDay,
  onSuccess
}) => {
  const dispatch = useDispatch()
  const [addingToCart, setAddingToCart] = useState(false)
  const [addedToCart, setAddedToCart] = useState(false)
  const { cartId, addSimpleProduct } = useCart()
  const frequencyInDays = shipmentFrequency * 7
  const { addPromotionToCart, data: promotionResponse, loading } = useAddPromotionToCart()

  useEffect(() => {
    const addPromo = async () => {
      await addPromotionToCart(sku)
      if (cartId) {
        dispatch(fetchCart(cartId))
      }
    }

    if (addedToCart && isPromotion) {
      // eslint-disable-next-line
      addPromo()
    }
    // eslint-disable-next-line
  }, [addedToCart, isPromotion, sku])

  useEffect(() => {
    if (addedToCart && promotionResponse && !loading) {
      onSuccess?.(true)
    }
    // eslint-disable-next-line
  }, [promotionResponse, addedToCart, loading])

  function handleAddSimpleToCart () {
    setAddingToCart(true)
    const cartItems = [{
      quantity: qty,
      sku: sku,
      frequency_in_cart: frequencyInDays.toString() ?? null,
      survey_referral: 1,
      uses_by_day: quantityPerDay
    }]

    addSimpleProduct({
      sku,
      cartItems,
      options: {
        callback: {
          onSuccess: () => setAddedToCart(true)
        }
      }
    })
  }

  return (
    <>
      <BtnWrap>
        <Button
          isLoading={addingToCart || loading}
          isDisabled={!cartId}
          onClick={handleAddSimpleToCart}
          type='button'
        >
          Let’s Start Saving Today!
        </Button>
      </BtnWrap>
    </>
  )
}
